import { Profile } from "@assets";
import { ActionItem } from "@components/ActionItem";
import { Button } from "@components/Button";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { useAllocateFundsFlow, useModal, useTheme, useUser } from "@hooks";
import { Translations, i18n } from "@i18n";
import { GenericErrorContent } from "@routes/AllocateFundsRoute/GenericErrorContent";
import { styles } from "./styles";
export const SelectBeneficiaryModal = () => {
  const { theme } = useTheme();

  const { dismiss } = useModal();
  const { beneficiaries } = useUser();
  const { setAllocateFundsProps } = useAllocateFundsFlow();

  if (!beneficiaries?.length) {
    return <GenericErrorContent />;
  }

  return (
    <div style={styles.container}>
      {beneficiaries.map((b, index) => {
        if (!b?.firstName || !b.id) return null;

        return (
          <>
            <ActionItem
              key={`beneficiary-${b.id}-${index}`}
              leftIcon={<Profile fill={theme.icon.default} />}
              title={b.firstName}
              onClick={() => {
                setAllocateFundsProps({
                  beneficiaryId: b.id,
                });
                dismiss();
              }}
            />
            <Spacing size={SpacingSizes.XS} />
          </>
        );
      })}
      <Spacing size={SpacingSizes.XS} />

      <Button title={i18n.t(Translations.SelectBeneficiaryModalPrimaryCTA)} onClick={dismiss} />
    </div>
  );
};
